import Util from '../../util/index.js';
export default class Matrix {
  constructor(args) {
    if (!Util.isArray(args) || args.length === 0) {
      throw new Error('constructor doesn\'t accept a array with zero dimension');
    }
  }
  calcMatrixDimension() {}
  calcMatrixDet() {}
  transition() {}
  unTransition() {}
}